<template>
  <v-container>
    <v-card>
      <core-value-faq-drawer
        :show="info_drawer"
        v-on:close="info_drawer = false"
      ></core-value-faq-drawer>
      <v-container>
        <v-row>
          <v-col cols="auto" class="my-auto pa-6">
            <v-img :src="$images.CORE_VALUES" width="80"></v-img>
          </v-col>
          <v-col cols="auto">
            <v-card-title>
              Select your {{ (coreValues.length + 1) | ordinal_words }}
              {{ t("core_values.title_s") | lower }}
              <v-btn icon color="lighttext" @click="info_drawer = !info_drawer">
                <v-icon>info</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-subtitle>
              Click on a card below to view more details, customize the name &
              add it to your list
            </v-card-subtitle>
          </v-col>
          <v-spacer> </v-spacer>
          <v-col cols="auto" class="my-auto mr-6">
            <v-btn color="accent" @click="done">Done</v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-item-group multiple max="1" v-model="selected">
              <v-container fluid>
                <v-row dense>
                  <v-col
                    v-for="(cv, i) in sorted_coreValues"
                    :key="i"
                    cols="12"
                    lg="3"
                    md="4"
                    sm="6"
                    class="pa-3"
                  >
                    <v-item
                      v-slot:default="{ active, toggle }"
                      :value="cv"
                      :class="cv.id ? 'v-item--active' : ''"
                      :disabled="cv.id !== ''"
                    >
                      <v-card
                        :outlined="cv.id !== '' || active"
                        class="text-center px-4 pt-4 option-card"
                        @click="toggle"
                        height="100%"
                      >
                        <v-icon v-if="cv.id || active" color="primary">
                          check_circle
                        </v-icon>
                        <inline-svg
                          :width="150"
                          :height="150"
                          v-if="cv.badgeUrl"
                          :fill="
                            !cv.id && !active
                              ? 'white'
                              : $vuetify.theme.themes.light.primary
                          "
                          style="width: 100%;"
                          :src="cv.badgeUrl"
                        />
                        <v-icon v-else color="primary" :size="150">edit</v-icon>
                        <v-card-subtitle>
                          {{ cv.name }}
                        </v-card-subtitle>
                      </v-card>
                    </v-item>
                  </v-col>
                  <v-col cols="12" lg="3" md="4" sm="6" class="pa-3">
                    <v-item
                      v-slot:default="{ active, toggle }"
                      :value="{ badgeUrl: $images.CUSTOM_CORE_VALUE_BADGE }"
                      class="v-item--active"
                    >
                      <v-card
                        outlined
                        class="text-center px-4 pt-4 option-card"
                        @click="toggle"
                        height="100%"
                      >
                        <v-icon v-if="active" color="primary">
                          check_circle
                        </v-icon>
                        <v-row class="my-auto">
                          <v-col cols="12">
                            <v-card-title>
                              <h2 class="primary--text break-word">
                                Can't find your
                                {{ t("core_values.title_short_s") | lower }}?
                              </h2>
                            </v-card-title>
                            <v-btn outlined color="primary">Add your own</v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <add-core-value-dialog
      :coreValue="selectedCoreValue"
      v-on:cancel="clearSelection"
      v-on:save="clearSelection"
    ></add-core-value-dialog>
  </v-container>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import { mapGetters } from "vuex";
import AddCoreValueDialog from "@/components/company/AddCoreValueDialog";
import CoreValueFaqDrawer from "@/components/company/CoreValueFaqDrawer";
export default {
  name: "AddCoreValue",
  components: {
    "inline-svg": InlineSvg,
    "add-core-value-dialog": AddCoreValueDialog,
    "core-value-faq-drawer": CoreValueFaqDrawer
  },
  data: () => ({
    selected: [],
    selectedCoreValue: null,
    info_drawer: false
  }),
  watch: {
    selected: function(val) {
      if (val.length) {
        let cv = val[0];
        if (!cv.categoryName) {
          cv.categoryName = "add your own";
        }
        this.selectedCoreValue = cv;
      } else {
        this.selectedCoreValue = null;
      }
    }
  },
  computed: {
    isCurrentCoreValue() {
      return cv => {
        return this.coreValues.filter(x => x.categoryId == cv.id).length > 0;
      };
    },
    getCurrentCoreValue() {
      return cv => {
        return this.coreValues.find(x => x.categoryId == cv.id);
      };
    },
    sorted_coreValues() {
      let existingCategoryIds = (this.coreValues || []).map(x => x.categoryId);
      let categoriesWithNoExisting = (this.coreValuesCategories || [])
        .filter(x => existingCategoryIds.indexOf(x.id) < 0)
        .map(x => ({
          categoryId: x.id,
          name: x.name,
          categoryName: x.name,
          badgeUrl: x.badgeUrl
        }));

      return this._.concat(this.coreValues || [], categoriesWithNoExisting);
    },
    ...mapGetters({
      coreValues: "company/coreValues",
      coreValuesCategories: "lookup/corevalue_categories",
      tasks: "task/tasks"
    })
  },
  created() {
    this.getCoreValues();
  },
  methods: {
    getCoreValues() {
      this.$store
        .dispatch("company/getCoreValues")
        .catch(error => {
          this.logError(error);
          this.$root.$alert("Error Occurred", "An error occured while loading");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearSelection() {
      this.selected = [];
    },
    done() {
      this.$router.push({ path: "/company" });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
